import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AuthService } from 'src/app/service/auth.service';
import { User } from 'src/app/model/user.model';
import { Router } from '@angular/router';
import { Role } from 'src/app/model/role.model';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.css']
})
export class SidenavComponent implements OnInit {
  @Output() sidenavClose = new EventEmitter();
  currentUser: User;

  constructor(
    private authService: AuthService,
    private router: Router) {
      this.authService.currentUser.subscribe(x => this.currentUser = x);
  }

  ngOnInit() {
  }

  public onSidenavClose = () => {
    this.sidenavClose.emit();
  }

  onLogout() {
    this.sidenavClose.emit();
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  get isAdmin() {
    return this.currentUser && this.currentUser.role === Role.Admin;
}

  get isUser() {
    return this.currentUser && this.currentUser.role === Role.User;
  }

  get isInstructor() {
    return this.currentUser && this.currentUser.role === Role.Instructor;
  }

}
